import FormInput from '../../../components/forms/input';
import type { PartyEntry } from '../../types';

interface SimplePartyFieldsProps {
    entry: PartyEntry;
    errors?: Record<string, string>;
    onUpdate: (field: keyof PartyEntry, value: string) => void;
    nameLabel: string;
    id: string;
}

export default function SimplePartyFields({ entry, errors, onUpdate, nameLabel, id }: SimplePartyFieldsProps) {
    return (
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            <FormInput
                title={nameLabel}
                id={`${id}-name`}
                placeholder="e.g  Adebayo Oluwaseun Johnson"
                value={entry.name}
                onChange={(e) => onUpdate('name', e.target.value)}
                variant="white"
                error={errors?.name}
            />
            <FormInput
                title="Address"
                id={`${id}-address`}
                placeholder="House number, street, area, city, state"
                value={entry.address}
                onChange={(e) => onUpdate('address', e.target.value)}
                variant="white"
                error={errors?.address}
            />
            <FormInput
                title="Phone Number"
                id={`${id}-phone`}
                placeholder="e.g. +234 801 234 5678"
                value={entry.phone}
                onChange={(e) => onUpdate('phone', e.target.value)}
                variant="white"
                error={errors?.phone}
            />
            <FormInput
                title="Email"
                id={`${id}-email`}
                type="email"
                placeholder="e.g.  yourmail@mail.com"
                value={entry.email || ''}
                onChange={(e) => onUpdate('email', e.target.value)}
                variant="white"
                error={errors?.email}
            />
        </div>
    );
}
